export default "__VITE_ASSET__DqMv6vdc__"